import React, { useEffect } from 'react'
import { useCDRenewalDetail, useCDRenewalPayment } from '../../services/hooks'
import { Button, Card, Divider, Form, Input, message, Radio, Tag } from 'antd'

const CDRenewal = () => {
  const { data: jacketDetail, loading: detailLoading, run: fetchDetail } = useCDRenewalDetail({ manual: true })

  const { run: fetchPayment, loading: paymentLoading } = useCDRenewalPayment({
    manual: true,
    onSuccess: (paymentData) => {
      window.location.replace(paymentData.url)
    },
    onError: (error) => {
      if (error && error.code === 'system.success') {
        window.location.reload()
      }
    },
  })

  const [form] = Form.useForm()
  const [hasDetail, setHasDetail] = React.useState(false)
  const [isPaid, setIsPaid] = React.useState(false)

  useEffect(() => {
    fetchDetail()
  }, [fetchDetail])

  useEffect(() => {
    if (jacketDetail && jacketDetail.instructorNumber) {
      setHasDetail(true)
      form.setFieldsValue({
        instructorNumber: jacketDetail.instructorNumber,
        level: jacketDetail.level,
      })

      setIsPaid(jacketDetail.paymentMethod !== null && jacketDetail.paymentMethod !== undefined)
    } else {
      setHasDetail(false)
      setIsPaid(false)
    }
  }, [jacketDetail, form])

  const handlePayment = async () => {
    try {
      const values = await form.validateFields()
      fetchPayment(values)
    } catch (error) {
      console.error('获取支付信息失败:', error)
      message.error('获取支付信息失败，请稍后重试')
    }
  }

  return (
    <div className="cd-renewal-container">
      <div className="cd-renewal-header">
        <h2>CD Renewal</h2>
      </div>

      {detailLoading ? (
        <p>加载中...</p>
      ) : (
        <Card className="cd-renewal-content">
          <Form form={form} layout="vertical" className="cd-renewal-form">
            <div
              style={{ marginBottom: '20px', fontSize: '16px', lineHeight: '1.8' }}
              className="cd-renewal-thanks-text"
            >
              感謝您報名參加本年度課程總監線下更新。
              <br />
              請填寫以下信息並完成付款。
            </div>

            <Form.Item label="會員編號 Member Number" name="instructorNumber">
              <Input placeholder="會員編號" disabled />
            </Form.Item>

            <div className="form-row">
              <Form.Item label="課程總監禮遇計劃" name="level" rules={[{ required: true }]}>
                <Radio.Group
                  placeholder="課程總監禮遇計劃"
                  disabled={isPaid}
                  style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}
                >
                  <Radio.Button value="课程总监">課程總監</Radio.Button>
                  <Radio.Button value="白银总监">白銀總監</Radio.Button>
                  <Radio.Button value="黄金总监">黃金總監</Radio.Button>
                  <Radio.Button value="白金总监">白金總監</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </div>
          </Form>

          {hasDetail && (
            <>
              <Divider />
              <div className="payment-section" style={{ display: 'flex', gap: '10px' }}>
                {isPaid ? (
                  <Tag
                    color="success"
                    style={{ fontSize: '16px', height: '40px', lineHeight: '40px', padding: '0 16px' }}
                  >
                    已付款
                  </Tag>
                ) : (
                  <Button
                    type="primary"
                    size="large"
                    loading={paymentLoading}
                    onClick={handlePayment}
                    className="payment-button"
                  >
                    去支付
                  </Button>
                )}
              </div>
            </>
          )}
        </Card>
      )}
    </div>
  )
}

export default CDRenewal
